import { useOutletContext } from 'react-router'
import { useTranslation } from 'react-i18next'
import { useAuth } from '@structural-climbing/auth'
import { FamilySection } from '../features/family/FamilySection'
import { useMemberCheckInStatus } from '../features/checkin/useMemberCheckInStatus'
import { useGymBranding } from '../features/gym/useGymBranding'
import { Page } from '../design/Page'
import type { GymContext } from '../layouts/GymLayout'

/**
 * Contul meu › Familie: adding, editing and removing children, and giving them
 * a login of their own.
 *
 * This was a card at the bottom of Home. Home keeps what a parent needs at the
 * desk (each child's code, who is inside, checking them out); the forms live
 * here, where there is room for them. A green dot still says who is inside.
 */
export function FamilyPage() {
  const { gymId } = useOutletContext<GymContext>()
  const { user, getAccessTokenSilently } = useAuth()
  const { t } = useTranslation()
  const apiUrl = import.meta.env.VITE_API_URL as string

  const branding = useGymBranding(gymId, apiUrl)
  const { childCheckIns } = useMemberCheckInStatus(
    user?.sub as string | undefined,
    gymId,
    apiUrl,
    getAccessTokenSilently,
  )

  return (
    <Page>
      <h1 className="sr-only">{t('family.title')}</h1>
      <FamilySection
        gymId={gymId}
        childCheckIns={childCheckIns}
        gymTimezone={branding?.timezone ?? null}
      />
    </Page>
  )
}
